import { useEffect } from 'react';

/**
 * Preview landing, receives a preview token in the URL hash, stores it in
 * sessionStorage (tab-scoped, so it never disrupts the facilitator's admin
 * login in other tabs) and drops into the real journey.
 */
export default function LabsPreviewLanding() {
  useEffect(() => {
    const hash = window.location.hash || '';
    const token = new URLSearchParams(hash.replace(/^#/, '')).get('token');
    if (token) {
      sessionStorage.setItem('futurepath_token', token);
      window.location.replace('/app/dashboard');
    } else {
      window.location.replace('/AFPLabs');
    }
  }, []);
  return (
    <div className="min-h-screen bg-navy-gradient flex items-center justify-center text-slate-300">
      Loading preview…
    </div>
  );
}
